import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-global flex justify-between items-center relative" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card-global mt-9 space-y-8" }
const _hoisted_4 = { class: "flex-grow bg-gray-50 rounded-lg p-3 border border-gray-100" }
const _hoisted_5 = {
  key: 0,
  class: "entity-details bg-white divide-y"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 p-2 text-left text-gray-400" }, "ID", -1)
const _hoisted_8 = { class: "flex-1 min-w-0 p-2 text-left" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_11 = { class: "flex-1 p-2 text-left" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_14 = { class: "flex-1 p-2 text-left" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_17 = { class: "flex-1 p-2 text-left" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_20 = { class: "flex-1 p-2 text-left" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_23 = { class: "flex-1 p-2 text-left" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_26 = { class: "flex-1 p-2 text-left" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_29 = { class: "flex-1 p-2 text-left" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_32 = { class: "flex-1 p-2 text-left" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_35 = { class: "flex-1 p-2 text-left" }
const _hoisted_36 = { class: "font-semibold" }

import BackButton from "@/components/common/BackButton.vue";
import { computed, ref, onMounted } from "vue";
import Role from "@/types/roles/Role";
import { useRoute } from "vue-router";
import StatusLabel from "@/components/common/StatusLabel.vue";
import PublicId from "@/components/common/PublicId.vue";
import { useStore } from "vuex";
import { RoleActions } from "@/store/modules/role/actions";
import { RoleGetters } from "@/store/modules/role/getters";
import { t } from "@/i18n";
import { getPermissionGroups } from "@/utils/rolePermissions";
import { formatDateTime } from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();

const role = ref<Role>();

const systemConfigLabels = [
  { key: "user", label: t("roleForm.user") },
  { key: "job", label: t("common.job") },
  { key: "company", label: t("common.company") },
  { key: "role", label: t("common.role") },
  { key: "nomenclature", label: t("roleForm.nomenclature") },
  { key: "processTemplate", label: t("roleForm.processes") },
  { key: "documentConstructor", label: t("roleForm.constructor") },
  { key: "documentTemplate", label: t("roleForm.template") },
  { key: "logs", label: t("roleForm.viewLogs") },
];

const systemConfigEntries = computed(() =>
  systemConfigLabels.map((item) => ({
    ...item,
    enabled: Boolean(
      (role.value?.systemConfig as Record<string, boolean> | undefined)?.[item.key]
    ),
  }))
);

const permissionEntries = computed(() => role.value?.permissions ?? []);
const permissionGroups = computed(() =>
  getPermissionGroups(permissionEntries.value)
);

onMounted(async () => {
  await store.dispatch(RoleActions.FETCH_ONE, route.params.id);
  role.value = store.getters[RoleGetters.GET_CURRENT];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'RoleList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("roleDetails.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (role.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(PublicId, {
                    value: role.value.id
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("common.title")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(role.value.name), 1)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("roleForm.adGroup")), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(role.value.adGroup || "—"), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("common.status")), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(StatusLabel, {
                    label: role.value.status
                  }, null, 8, ["label"])
                ])
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)("roleDetails.userCount")), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(role.value.userCount ?? 0), 1)
              ]),
              _createElementVNode("li", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("common.createdAt")), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(formatDateTime)(role.value.createdAt)), 1)
              ]),
              _createElementVNode("li", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)("common.updatedAt")), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(formatDateTime)(role.value.updatedAt)), 1)
              ]),
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)("roleForm.systemConfig")), 1),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(systemConfigEntries), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.key
                    }, _toDisplayString(item.label) + ": " + _toDisplayString(item.enabled ? _unref(t)("common.yes") : _unref(t)("common.no")), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("li", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)("roleForm.documentConfig")), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)("roleForm.viewDocument")) + ": " + _toDisplayString(role.value.documents?.canRead ? _unref(t)("common.yes") : _unref(t)("common.no")), 1)
              ]),
              _createElementVNode("li", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("roleForm.permissions")), 1),
                _createElementVNode("div", _hoisted_35, [
                  (_unref(permissionEntries).length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(permissionGroups), (group) => {
                        return (_openBlock(), _createElementBlock("section", {
                          key: group.key,
                          class: "mb-4 space-y-2"
                        }, [
                          _createElementVNode("h3", _hoisted_36, _toDisplayString(group.label), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (permission) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: permission.value
                            }, _toDisplayString(permission.label), 1))
                          }), 128))
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.no")), 1)
                      ], 64))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})